<template>
    <div>
        <a-button type="primary" @click="addTeacher" style="margin-bottom: 10px;">加入校区
        </a-button>
        <a-modal :visible="teacherVisible" title="教师" @ok="teacherSave" @cancel="modalCancel">
            <a-form>
                
              <a-select optionFilterProp="children" show-search v-model="teacherForm.admin_id" placeholder="任课老师"
                        allow-clear>
                  <a-select-option
                          v-for="(item) in courseTeacherList"
                          :key="item.id"
                          :value="item.id"
                  >{{item.nickname}}-{{item.mobile}}
                  </a-select-option>
              </a-select>
            </a-form>
        </a-modal>
        <a-table :dataSource="teacherList" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading" 
            bordered>
            <a-table-column key="username" title="账号" data-index="username" />
            <a-table-column key="nickname" title="姓名" data-index="nickname" />
            <a-table-column key="mobile" title="手机号码" data-index="mobile" />
            <a-table-column key="email" title="电子邮件" data-index="email" />
            <a-table-column key="campusname" title="校区" data-index="campusname" />
            <a-table-column key="create_time" title="创建时间" data-index="create_time" />
            <a-table-column key="status" title="状态">
                <template slot-scope="item">
                    <span v-if="item.status==1">可用</span>
                    <span v-if="item.status==0">已禁用</span>
                </template>
            </a-table-column>
            <a-table-column key="active" title="操作">
                <template slot-scope="item">
                   <!-- <a-button v-if="item.status==0" @click="changeTeacherStatus({id:item.id,status:1})" class="active_btn"
                        size="small" type="link">启用
                    </a-button> -->
                    <a-button  @click="removcampuseteacher({admin_id:item.id,campus_id:campus_id })" class="active_btn"
                        size="small" type="link">移除
                    </a-button>
                </template>
            </a-table-column>
        </a-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                teacherList: [],
                campus_id: this.id,
                teacherVisible: false,
                teacherForm: {
                    admin_id: undefined,
                    campus_id: this.id,
                },
                 courseTeacherList: [],
            }
        },
        mounted() {
            this.getCampusTeacherList();
            this.changeFormCampus(this.campus_id);
        },
        methods: {
            getCampusTeacherList() {
                this.$axios
                    .post("/api/OrgCampus/getteacher", {
                        data: {
                            campus_id: this.campus_id
                        },
                        pageinfo: {
                            pageSize: 9999
                        }
                    })
                    .then(res => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定"
                            });
                        } else {
                            this.teacherList = res.data.data;
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            addTeacher() {
                this.teacherVisible = true;
            },
            modalCancel() {
                this.teacherVisible = false;
            },
            changeFormCampus(campus_id) {
              this.getCourseTeacherList({campus_id: campus_id});
            },
            getCourseTeacherList() {
              this.$axios
                .post("/api/OrgOrganization/getorgteacher", {pageinfo: {pageSize: 9999}})
                .then(res => {
                  if (res.code != 200) {
                    this.$error({
                      title: "错误",
                      content: res.msg,
                      okText: "确定"
                    });
                  } else {
                    this.courseTeacherList = res.data.data;
                  }
                })
                .catch(err => {
                  console.error(err);
                });
            },
            teacherSave() {
                this.$axios
                    .post("/api/OrgCampus/addcampusteacher", {
                        data: this.teacherForm
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.getCampusTeacherList();
                            this.teacherVisible = false;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            removcampuseteacher(data)
            {
                this.$axios
                    .post("/api/OrgCampus/removcampuseteacher", {
                        data: data
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.getCampusTeacherList();
                            this.teacherVisible = false;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
                
            },
        },
        name: 'child',
        props: {
            id: {
                type: String, // 限定父组件传过来值的类型
                required: true, //是否是必须传的值
            },
            total: {
                default: 11, //默认值
            }
        }
    }
</script>
<style>
    .active_btn {
        margin-left: 5px;
    }
</style>
